import { infoStore, searchStore } from '~/stores'

// Called when switching to another section through the main navigation, so that remembered
// search queries only survive navigating back and forth within the search flow.
export function clearRememberedSearchQueries() {
  searchStore.setLastQuery(null)
  infoStore.clearSearchQueries()
}

export function parseMessageData(messageData: any) {
  if (typeof messageData !== 'object') { return null }
  const type = messageData.type
  const data = messageData.data

  if (type !== 'navigate' || typeof data !== 'string') { return null }

  return {type, data}
}